const renderInline = line =>
	line
		.split(/\*\*(.+?)\*\*/g)
		.map((part, i) => (i % 2 ? <strong key={i}>{part}</strong> : part));

export const formatMarkdown = text =>
	text?.split('\n').map((line, i, lines) => (
		<span key={i}>
			{renderInline(line)}
			{i < lines.length - 1 && <br />}
		</span>
	)) ?? null;
